(function() {
  'use strict';
  
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  
  function initMobileSlider(slider) {
    const track = slider.querySelector('.product-card__mobile-slider-track');
    const dots = slider.querySelectorAll('.product-card__mobile-dot');

    if (!track || !dots.length) return;

    track.scrollLeft = 0;

    slider.setAttribute('data-slider-initialized', 'true');

    let currentIndex = 0;
    
    const updateDots = () => {
      const slideWidth = track.offsetWidth;
      
      if (slideWidth === 0) return;
      
      const scrollLeft = track.scrollLeft;
      const newIndex = Math.round(scrollLeft / slideWidth);
      
      if (newIndex !== currentIndex) {
        currentIndex = newIndex;
        dots.forEach((dot, index) => {
          const isActive = index === newIndex;
          if (isActive) {
            dot.classList.add('product-card__mobile-dot--active');
            dot.setAttribute('aria-pressed', 'true');
          } else {
            dot.classList.remove('product-card__mobile-dot--active');
            dot.setAttribute('aria-pressed', 'false');
          }
        });
      }
    };
    
    const scrollToSlide = (index) => {
      const slideWidth = track.offsetWidth;
      
      if (slideWidth === 0) return;
      
      track.scrollTo({
        left: slideWidth * index,
        behavior: 'smooth'
      });
    };
    
    track.addEventListener('scroll', debounce(updateDots, 10), { passive: true });
    
    dots.forEach((dot, index) => {
      const handleActivation = (e) => {
        e.preventDefault();
        e.stopPropagation();
        scrollToSlide(index);
      };
      
      dot.addEventListener('click', handleActivation);
      
      dot.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleActivation(e);
        }
      });
    });
    
    updateDots();
  }
  
  function initAllSliders() {
    const sliders = document.querySelectorAll('[data-mobile-slider]');
    sliders.forEach(slider => {
      if (!slider.hasAttribute('data-slider-initialized')) {
        initMobileSlider(slider);
      }
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSliders);
  } else {
    initAllSliders();
  }

  document.addEventListener('recommendations:loaded', initAllSliders);

  if (typeof window.MutationObserver !== 'undefined') {
    const observer = new MutationObserver(debounce(() => {
      initAllSliders();
    }, 250));

    const observeTarget = document.getElementById('ProductGridContainer') || document.body;
    observer.observe(observeTarget, {
      childList: true,
      subtree: true
    });
  }
})();
